import { z } from 'zod';

/**
 * Una categoria di "Aspetto" del PG (parte della creazione personaggio).
 *
 * Ogni classe ne ha tipicamente 3-4 (Occhi, Corpo, Vestiario, ecc.) e per
 * ognuna il giocatore sceglie una delle opzioni proposte.
 *
 * Esempio Barbaro:
 *   { label: 'Occhi', options: ['Tormentati', 'Spiritati', 'Selvaggi'] }
 *
 * Lo schema descrive la **definizione** della categoria nella ClassDefinition;
 * la scelta del giocatore vive sulla scheda PG come stringa testuale.
 */
export const AspettoCategoriaSchema = z.object({
  /** Etichetta della categoria (es. 'Occhi', 'Corpo', 'Vestiario'). */
  label: z.string().min(1).max(50),
  /** Opzioni proposte dalla classe (almeno 2). */
  options: z.array(z.string().min(1).max(150)).min(2),
});
export type AspettoCategoria = z.infer<typeof AspettoCategoriaSchema>;
